// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DefaultLayoutMap from "./DefaultLayoutMap.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function DefaultLayoutContentPage$Layout(props) {
  return JsxRuntime.jsx(DefaultLayoutMap.Content.make, {
              children: props.children
            });
}

var Layout = {
  make: DefaultLayoutContentPage$Layout
};

function DefaultLayoutContentPage(props) {
  return JsxRuntime.jsx(DefaultLayoutContentPage$Layout, {
              children: JsxRuntime.jsx(ReactRouterDom.Outlet, {})
            });
}

var make = DefaultLayoutContentPage;

export {
  Layout ,
  make ,
}
/*  Not a pure module */
